import { ReactNode } from "react";
import { TableHead } from "@/components/ui/table";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface TableHeadWithTooltipProps {
  children: ReactNode;
  tooltip: ReactNode;
  className?: string;
  /** Inline styles forwarded to the <th> -- e.g. the fixed column widths a `table-fixed` layout
   * requires (WEB-010, design-conformance pass item 2). Without this, every column on a
   * `table-fixed` table loses its explicit width the moment its header switches to this component. */
  style?: React.CSSProperties;
  tooltipClassName?: string;
}

export function TableHeadWithTooltip({
  children,
  tooltip,
  className,
  style,
  tooltipClassName,
}: TableHeadWithTooltipProps) {
  return (
    <TableHead className={className} style={style}>
      <TooltipProvider delayDuration={150}>
        <Tooltip>
          <TooltipTrigger
            className="cursor-help border-b border-dotted border-muted-foreground"
            onClick={(e) => e.preventDefault()}
          >
            {children}
          </TooltipTrigger>
          <TooltipContent className={cn("max-w-xs text-left", tooltipClassName)}>
            {tooltip}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </TableHead>
  );
}
